import PropTypes from 'prop-types';
import colors from './constants/colors';
import styled from 'styled-components';

const Label = styled.label`
  color: ${({ errorMessage }) => {
    if (errorMessage) {
      return colors.opalFlame;
    }
    return colors.eerieBlack;
  }};
  font-size: 14px;
  font-weight: 450;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  transition: all 0.125s ease-out;
  z-index: 2;
`;

export default Label;

Label.propsTypes = {
  errorMessage: PropTypes.string,
};

Label.defaultProps = {
  errorMessage: undefined,
};
